import { Controller } from "@hotwired/stimulus"
import {
  createHereMap,
  detailBubble,
  disposeHereMap,
  singleBubble,
  fitToObjects,
} from "../helpers/here_map_helpers"

// Tasks map tab: one balloon marker per filtered task. A task without its own coordinates
// is placed on its site server-side, so there is nothing to toggle here.
//
// Bubble labels come in as a value rather than being written here: this file would
// otherwise be the only user-facing German outside config/locales.
export default class extends Controller {
  static targets = ["map"]
  static values = { taskMarkers: Array, labels: Object }

  connect() {
    createHereMap(this.mapTarget, { center: { lat: 51.1657, lng: 10.4515 }, zoom: 6 })
      .then((ctx) => this.addMarkers(ctx))
      .catch((error) => console.error("HERE map failed to load", error))
  }

  // The status tabs swap this frame in and out; release the engine or every switch leaks a
  // WebGL context until the browser starts refusing new ones.
  disconnect() {
    disposeHereMap(this.map)
    this.map = null
  }

  addMarkers({ H, map, ui }) {
    this.map = map
    const showBubble = singleBubble(H, ui)

    const taskObjects = this.taskMarkersValue.map((marker) => {
      const position = { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) }
      const object = new H.map.Marker(position)
      object.addEventListener("tap", () => {
        // Pan the marker into view but leave the zoom exactly where the user put it — an
        // automatic zoom jump on every click makes the map unusable.
        map.getViewModel().setLookAtData({ position }, true)
        showBubble(position, this.taskBubble(marker))
      })
      return object
    })
    taskObjects.forEach((object) => map.addObject(object))

    fitToObjects(H, map, taskObjects)
  }

  taskBubble(marker) {
    const labels = this.labelsValue

    return detailBubble(
      [
        [labels.task, marker.name],
        [labels.site, marker.site_name],
        [labels.address, marker.address],
      ],
      { href: `/tasks/${marker.id}`, linkLabel: labels.link },
    )
  }
}
